import { TmnButtonBase } from '@trumedianetworks/tmn-core-components/src/tmn-button/tmn-button-base';
import { withRouting } from './route-base';

window.customElements.define('routed-button', withRouting()(TmnButtonBase));
